<template>
  <AtomLink
    :url="url"
    class="bg-white hover:bg-app-primary-1-red--fire-brick text-app-primary-1-red--fire-brick hover:text-white transform transition duration-200 cursor-pointer group text-sm leading-none font-semibold items-center rounded"
  >
    <AtomIconChevronRight v-if="next" class="w-5" />
    <AtomIconChevronLeft v-else class="w-5" />
  </AtomLink>
</template>

<script setup lang="ts">
defineProps({
  url: { type: String, required: false, default: '/' },
  next: { type: Boolean, required: false, default: false },
})
</script>
